/**
 * RequireAuth — the storefront is for signed-in students only.
 *
 * Rocket07 delivers to a specific campus, so there is no useful anonymous
 * view: prices, stock and even the categories depend on which college you
 * belong to. Rather than let a guest browse someone else's catalogue and
 * discover at checkout that none of it applied, the whole app asks for
 * sign-in first.
 *
 * `loading` gets a spinner rather than a redirect — on a hard refresh the
 * stored token is verified asynchronously, and bouncing to /login during that
 * gap would sign people out every time they reloaded.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@/components/ui';
import { useCustomerAuth } from '@/context/CustomerAuthContext';
import { ROUTES } from '@/constants/routes';

export function RequireAuth({ children }) {
  const { status } = useCustomerAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="grid min-h-dvh place-items-center bg-canvas">
        <Spinner size="lg" className="text-primary-600" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    // Remember where they were headed so sign-in can return them there.
    return <Navigate to={ROUTES.login} state={{ from: location.pathname }} replace />;
  }

  return children;
}

export default RequireAuth;
